import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
  Card,
  CardContent,
  TextField,
} from '@mui/material';
import { green, red } from '@mui/material/colors';
import EditIcon from '@mui/icons-material/Edit';
import HearingIcon from '@mui/icons-material/Hearing';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { can } from '../../Conections/LogConections';
import { ListGreenHousesDataAPI } from '../../Conections/GreenhouseConection';

const GreenhousesShow = () => {
  const { getToken, getCompany } = useAuth();
  const goTo = useNavigate();

  const [greenhouses, setGreenhouses] = useState([]);
  const [greenhousesFiltrados, setGreenhousesFiltrados] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [greenhouseAEliminar, setGreenhouseAEliminar] = useState(null);
  const [busqueda, setBusqueda] = useState('');

  useEffect(() => {
    async function reloaduser() {
      if (getToken()) {
        const permisionCan = await can(getToken(), getCompany(), "/greenhouse/showgreenhouses");
        if (permisionCan) {
          const greenhousesSimulados = await ListGreenHousesDataAPI(getToken(), getCompany());
          setGreenhouses(greenhousesSimulados);
          setGreenhousesFiltrados(greenhousesSimulados);
        }
        else {
          goTo("/dashboard");
        }
      }
      else {
        goTo("/login");
      }
    };
    reloaduser();
  }, [getCompany, getToken, goTo]);

  useEffect(() => {
    const resultadosBusqueda = greenhouses.filter(greenhouse =>
      greenhouse.name.toLowerCase().includes(busqueda.toLowerCase()) ||
      greenhouse.address.toLowerCase().includes(busqueda.toLowerCase())||
      greenhouse.phone.toLowerCase().includes(busqueda.toLowerCase())
    );
    setGreenhousesFiltrados(resultadosBusqueda);
  }, [busqueda, greenhouses]);

  const handleEditar = (id) => {
    goTo("/greenhouse/editgreenhouse/"+id);
  };

  const handleEliminar = (greenhouse) => {
    setGreenhouseAEliminar(greenhouse);
    setOpenDialog(true);
  };

  const confirmarEliminacion = () => {
    if (greenhouseAEliminar) {
      console.log('Eliminar invernadero con id:', greenhouseAEliminar.id);
      // Aquí iría la lógica para eliminar el invernadero
      const greenhousesActualizados = greenhouses.filter(g => g.id !== greenhouseAEliminar.id);
      setGreenhouses(greenhousesActualizados);
      setGreenhousesFiltrados(greenhousesActualizados);
    }
    setOpenDialog(false);
    setGreenhouseAEliminar(null);
  };

  const handleMostrar = (id) => {
    goTo("/greenhouse/showgreenhouse/"+id);
  };

  const handleBusquedaChange = (event) => {
    setBusqueda(event.target.value);
  };

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <Typography variant="h4" component="h2" align="center" gutterBottom>
        Listado de Invernaderos
      </Typography>
      <Card>
        <CardContent>
          <TextField
            fullWidth
            label="Buscar invernaderos"
            variant="outlined"
            value={busqueda}
            onChange={handleBusquedaChange}
            sx={{ mb: 2 }}
          />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="tabla de invernaderos">
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Dirección</TableCell>
                  <TableCell>Telefono</TableCell>
                  <TableCell align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {greenhousesFiltrados.map((greenhouse) => (
                  <TableRow key={greenhouse.id}>
                    <TableCell>{greenhouse.name}</TableCell>
                    <TableCell> {greenhouse.address} </TableCell>
                    <TableCell> {greenhouse.phone} </TableCell>
                    <TableCell align="center">
                      <IconButton onClick={() => handleEditar(greenhouse.id)} color="default">
                        <EditIcon />
                      </IconButton>
                      {/*<IconButton onClick={() => handleEliminar(greenhouse)} color="default">
                        <DeleteIcon />
                      </IconButton>*/}
                      <IconButton onClick={() => handleMostrar(greenhouse.id)} color="default">
                        <VisibilityIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ textAlign: 'center' }}>
          <WarningIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
          <DialogTitle id="alert-dialog-title">
            {"¿Está seguro de que desea eliminar este invernadero?"}
          </DialogTitle>
          <DialogContentText id="alert-dialog-description">
            Esta acción no se puede deshacer. Se eliminará permanentemente el invernadero
            {greenhouseAEliminar && ` "${greenhouseAEliminar.nombre}"`}.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button onClick={() => setOpenDialog(false)} variant="contained" color="primary">
            Cancelar
          </Button>
          <Button onClick={confirmarEliminacion} variant="contained" color="error" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default GreenhousesShow;